import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { store } from '@/state/store'
import '@greenglobal/greencore.fe.table/dist/index.css'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { GreenCoreProvider } from '@greenglobal/greencore.fe.common'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <BrowserRouter basename={process.env.REACT_APP_ROOT || '/'}>
    <Provider store={store}>
      <GreenCoreProvider language='VN'>
        <App />
      </GreenCoreProvider>
    </Provider>
  </BrowserRouter>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
